import { Backdrop, Button, CircularProgress, Typography } from '@mui/material';
import { AuthInput, FormCard, PrimaryButton } from '../login';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useTranslation } from '../../hooks/useTranslation';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import { HOST_API } from '../../config/hosts';

export function RecoverPasswordForm() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [successSent, setSuccessSent] = useState(false);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleForgotPassword();
    }
  };

  const handleForgotPassword = async () => {
    if (isLoading) return;
    setIsLoading(true);

    try {
      const response = await fetch(`${HOST_API}/v1/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: '*/*',
        },
        body: JSON.stringify({
          username: username,
        }),
      });

      if (response.status === 200) {
        setSuccessSent(true);
      } else if (response.status === 429) {
        toast.warning(t('messages.tooManyRequests'), { theme: 'dark' });
      } else {
        toast.warning(t('messages.userNotFound'), { theme: 'dark' });
      }
    } catch (error) {
      toast.error(t('messages.userVerificationError'), { theme: 'dark' });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          onClick={() => navigate('/')}
          sx={{
            position: 'absolute',
            top: 24,
            left: 24,
            display: 'flex',
            alignItems: 'center',
            color: '#83D84D',
            textTransform: 'none',
            padding: 0,
            '&:hover': {
              backgroundColor: 'transparent',
            },
          }}
        >
          <ArrowBackIcon />
          <Typography fontSize={14} fontWeight={400}>
            {t('common.back')}
          </Typography>
        </Button>
      </div>

      {successSent ? (
        <FormCard>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '12px',
              textAlign: 'center',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                padding: '18px',
                borderRadius: '50%',
                backgroundColor: '#E9F7DF',
              }}
            >
              <CheckCircleIcon sx={{ color: '#83D84D', fontSize: 48 }} />
            </div>
            <Typography
              sx={{ fontSize: 24, fontWeight: 700, color: '#2C2C2C', fontFamily: 'Ubuntu' }}
            >
              {t('auth.emailSentPasswordRecovery')}
            </Typography>

            <Typography
              sx={{ fontSize: 14, fontWeight: 400, color: '#575757', fontFamily: 'Ubuntu' }}
            >
              {t('auth.emailSended')}
              <br />
              {t('auth.checkInbox')}
            </Typography>
          </div>
        </FormCard>
      ) : (
        <FormCard title={t('auth.recoverPassword')}>
          <AuthInput
            label={t('auth.user')}
            id="loginUser"
            type="text"
            placeholder={t('auth.userPlaceholder')}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onKeyDown={handleKeyDown}
            focusBorder="focus:border-[#83d84d]"
          />

          <PrimaryButton onClick={handleForgotPassword} disabled={isLoading}>
            {isLoading ? t('common.loading') : t('auth.recoverPassword')}
          </PrimaryButton>

          <Backdrop open={isLoading} style={{ zIndex: 9999 }}>
            <CircularProgress color="inherit" sx={{ color: '#83d84d' }} />
          </Backdrop>
        </FormCard>
      )}
    </>
  );
}
